// @flow
import StreetAddress from './StreetAddress';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import type { Props } from './StreetAddress';
import withGooglePlaces from 'components/api/components/WithGooglePlaces/WithGooglePlaces';
import { injectIntl } from 'react-intl';

// Actions
import {
  setPickupAddress,
  setDropoffAddress,
  setValetComments
} from 'store/reducers/appointment/valetDetails/actions';
import { cleanClutchError } from 'store/reducers/errors/actions';

// Selectors
import {
  getPickupAddress,
  getPickupDropoffSame,
  getDropoffAddress
} from 'store/reducers/appointment/valetDetails/selectors';
import { getExternalValetProvider } from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  pickupAddress: getPickupAddress(state),
  pickupDropoffSame: getPickupDropoffSame(state),
  dropoffAddress: getDropoffAddress(state),
  externalValet: getExternalValetProvider(state)
});

export default compose(
  withGooglePlaces,
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      setPickupAddress,
      setDropoffAddress,
      setValetComments,
      cleanClutchError
    }
  )
)(StreetAddress);



// WEBPACK FOOTER //
// ./src/components/molecules/StreetAddress/StreetAddressContainer.js